import { lazy, Suspense } from "react";
import FlightDealsLanding from "@/pages/FlightDealsLanding";

// Set REACT_APP_LANDING_MODE=full and rebuild to restore the complete product page.
const FullLanding = lazy(() => import("@/pages/Landing"));

export default function LandingEntry() {
  if (process.env.REACT_APP_LANDING_MODE === "full") {
    return <Suspense fallback={<div className="min-h-screen bg-[#0E1512]" role="status" aria-label="Loading TrailPulse" />}><FullLanding /></Suspense>;
  }
  return <FlightDealsLanding />;
}
